const apiBase = () => {
  const envUrl = import.meta.env.VITE_CLOUDFLARE_API_URL;
  if (envUrl && typeof envUrl === 'string' && envUrl.trim()) {
    return envUrl.trim().replace(/\/$/, '');
  }
  return 'http://127.0.0.1:8787';
};

export function extractGoogleDriveFileId(raw) {
  const s = String(raw || '');
  const file = s.match(/drive\.google\.com\/file\/d\/([a-zA-Z0-9_-]+)/i);
  if (file?.[1]) return file[1];
  const uc = s.match(/[?&]id=([a-zA-Z0-9_-]+)/i);
  if (/drive\.google/i.test(s) && uc?.[1]) return uc[1];
  return null;
}

export function buildImageSrcCandidates(raw) {
  const s = String(raw || '').trim();
  if (!s) return [];

  let url = s;
  if (!/^https?:\/\//i.test(url)) url = `https://${url}`;

  const id = extractGoogleDriveFileId(url);
  if (id) {
    const uc = `https://drive.google.com/uc?export=view&id=${id}`;
    const proxy = `${apiBase()}/public/image-proxy?url=${encodeURIComponent(uc)}`;
    return [
      proxy,
      `https://lh3.googleusercontent.com/d/${id}=s1920`,
      `https://lh3.googleusercontent.com/d/${id}`,
      `https://drive.google.com/thumbnail?id=${id}&sz=w1920`,
      uc,
    ];
  }

  if (/dropbox\.com/i.test(url) && url.includes('dl=0')) {
    url = url.replace('dl=0', 'raw=1');
  }

  return [`${apiBase()}/public/image-proxy?url=${encodeURIComponent(url)}`, url];
}

/**
 * Chuẩn hóa URL ảnh từ sheet (Drive/Dropbox thường chặn nhúng trực tiếp).
 * @deprecated dùng buildImageSrcCandidates cho UI
 */
export function normalizeImageUrlForDisplay(raw) {
  const list = buildImageSrcCandidates(raw);
  return list[list.length - 1] || '';
}

/** Preload một ảnh (thử lần lượt candidates). Luôn resolve (kể cả khi tất cả URL lỗi). */
export function preloadImageRaw(raw) {
  return new Promise((resolve) => {
    const urls = buildImageSrcCandidates(raw);
    if (urls.length === 0) {
      resolve();
      return;
    }
    let i = 0;
    const tryNext = () => {
      if (i >= urls.length) {
        resolve();
        return;
      }
      const img = new Image();
      img.onload = () => resolve();
      img.onerror = () => {
        i += 1;
        tryNext();
      };
      img.src = urls[i];
    };
    tryNext();
  });
}
